export const iconFontAwesomeScienceTemperatureHigh = (
	<i className="fa-solid fa-temperature-high"></i>
);
